import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ReactTyped } from "react-typed";
// import image from "../../../Assests/Landing Pic.svg";
import { ReactComponent as ImageOne } from "../../../Assests/trackright/imageOne.svg";
import { HomerWrap } from "../style";
import { animateScroll as scroll } from "react-scroll";

export const Home = ({ setColor }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setColor(false);
  }, []);

  const scrollToTop = () => {
    scroll.scrollToTop({
      duration: 100,
      smooth: "smooth",
    });
  };
  return (
    <HomerWrap>
      <Container fluid className="py-2 contain-margin" id="Home">
        <Row>
          <Col
            xl={8}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <div style={{ verticalAlign: "middle" }}>
              <h3 className="para text2">
                The Intelligent Platform
                <br /> for
                <span>
                  {" "}
                  <span></span>
                  <ReactTyped
                    strings={["Cargo", "Fleet", "Delivery", "Logistics"]}
                    typeSpeed={100}
                    loop
                    backSpeed={50}
                    showCursor={true}
                    className="organi"
                  />
                </span>
                <br />
                Management
              </h3>
              <Col xl={6}>
                {" "}
                <p className="color2 text1 text2">
                  TrackRight is an intelligent fleet, delivery, and container
                  management platform designed to give businesses real-time
                  visibility, control, and insights across their operations.
                  From live tracking to advanced analytics, TrackRight helps
                  organizations move smarter, safer, and more efficiently — all
                  from one unified system.
                </p>
              </Col>
              <Col xl={6}></Col>

              <div className="text2">
                <button
                  className="theme-outlinedbtn my-4 mx-2"
                  style={{
                    backgroundColor: "",
                    color: "green",
                    border: "1px solid green",
                    padding: "",
                    borderRadius: "8px",
                    fontSize: "17px",
                  }}
                  onClick={() => {
                    // navigate("/register");
                    navigate("/login");
                    scrollToTop();
                  }}
                >
                  Log In
                </button>{" "}
                <button
                  className="theme-filldbtn mx-2"
                  style={{ backgroundColor: "green" }}
                  onClick={() => {
                    navigate("/demo-booking-page");
                    scrollToTop();
                  }}
                >
                  Book a Demo
                </button>{" "}
              </div>
            </div>
          </Col>
          <Col xl={4}>
            <Container className="img-contain">
              <ImageOne style={{ Width: "700px", height: "auto" }} />
            </Container>
          </Col>
        </Row>
      </Container>
    </HomerWrap>
  );
};
